import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withWidth, withStyles } from "@material-ui/core";
import style from './styles.module.scss';
import styled from 'styled-components';
import SecondaryNav from './../components/SecondaryNav';
import SingleAndParcelsTabs from './../components/SingleAndParcelsTabs';
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as AuthActions from "./../../../../redux/actions/auth";
import * as DiamondsActions from "./../../../../redux/actions/diamonds";
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import numeral from 'numeral';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { isOtherShape } from 'logged_out/components/diamonds/All';
import getSymbolFromCurrency from 'currency-symbol-map';
import { convertToCurrency } from 'shared/functions/priceCalc';

import { RegisterOrLoginToSeePriceNotice } from './../DiamondDetails';

import { valuesMapAvailability } from 'logged_in_admin/components/dashboard/DiamondsAvailabilitySettings';

const styles = theme => ({
    noDecoration: {
        textDecoration: "none !important"
    }
});

function joinHenigArray(d, field) {
    return d[field] && d[field][0] && d[field][1] ? [d[field][0].From, d[field][1].To].filter(s => s).join(' to ') : '';
}

const CompareItem = styled(({ className, onCloseClick, emptyPlaceholder, dragHandleProps, isDragging, diamondItem = {}, isParcel }) => <div className={classNames(className, isDragging && 'active')}>
    {!emptyPlaceholder && <React.Fragment>
        <div className="tools">
            <div>
                <Tooltip title="Drag & Drop to reorder items">
                    <i className="compare" {...dragHandleProps} />
                </Tooltip>
            </div>
            <div>
                <i className="close" onClick={onCloseClick} />
            </div>
        </div>
        <div className="thumb">
            <img alt="" src={diamondItem.img} />
        </div>
    </React.Fragment>}
</div>)`
display: inline-block;
padding: 35px;
height: 240px;
min-width: 150px;

@media (max-width: 600px){
    min-width: 100%;
}

i{
    width: 40px;
    height: 40px;
    display: inline-block;
    background-size: 70%;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
}

.compare{
    
    background-image: url(/images/compare_icon.svg);
    :hover{
        background-image: url(/images/compare_icon_hover.svg);
    }
}
&.active .compare{
    background-image: url(/images/compare_icon_active.svg);
}
.close{
    background-image: url(/images/close.svg);
    :hover{
        background-image: url(/images/close_hover.svg);
        background-size: 90%;
    }
}

.tools{
    display: flex;
    justify-content: space-between;
    margin-left: -12px;
    margin-right: -12px;

    @media (max-width: 600px){
       margin-bottom: -16px;
    }
}
.thumb{
    width: 121px;
    height: 120px;
    background-color: transparent;
    padding: 8px;
    box-sizing: content-box;
    border-radius: 50%;
    overflow: hidden;
    position: relative;

    img{
        width: 100%;
        height: auto;
        object-fit: contain;
        position: relative;
        z-index: 1;
    }

    @media (max-width: 600px){
        width: 100%;
        height: 160px;
        
        img{
            width: 160px;
            margin: 0 auto;
            display: block;
        }
    }
}
`;

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const getItemStyle = (isDragging, { transform, ...draggableStyle }, isMobile) => {

    const styles = ({
        // some basic styles to make the items look a bit nicer
        userSelect: 'none',
        padding: 0,
        margin: 0,

        // change background colour if dragging
        //background: isDragging ? 'lightgreen' : 'grey',
        background: 'white',
        border: isDragging ? '1px solid #dddddd' : 'none',

        // styles we need to apply on draggables
        ...draggableStyle,

        opacity: isDragging ? 0.5 : 1,
    });

    if (!transform) {
        return styles;
    }

    // get x and y values from translate(x, y)
    const xPos = transform.substring(transform.indexOf('(') + 1, transform.indexOf(','));
    const yPos = transform.substring(transform.indexOf(',') + 1, transform.indexOf(')'))

    return ({
        ...styles,
        transform: `translate(${isMobile ? 0 : xPos}, ${isMobile ? yPos : 0})`,
    });
}

const getListStyle = (isDraggingOver, isMobile) => ({
    //background: isDraggingOver ? 'lightblue' : 'lightgrey',
    background: isDraggingOver ? '#fefefe' : 'white',
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    padding: 0,
    overflowX: isMobile ? 'none' : 'auto',
    overflowY: isMobile ? 'auto' : 'none',
    width: '100%',
    paddingBottom: 20
});

class Compare extends PureComponent {
    state = {
        sideDrawerOpen: false,
        tabsValue: 0,
        row: false,
    }

    componentDidMount() {
        const { selectCompare = () => { } } = this.props;
        //const { diamondId, page } = this.props.match.params;

        selectCompare();
    }

    openBag = (row) => {
        this.props.AuthActions.addToBag(row, () => {
            this.setState({ sideDrawerOpen: 'bag', row });
        });
    };
    openBagShare = () => {
        this.setState({ sideDrawerOpen: 'share' });
    };
    openPrice = () => {
        this.setState({ sideDrawerOpen: 'price' });
    };
    closeBag = () => {
        this.setState({ sideDrawerOpen: false, row: false });
    };

    onTabsChange = (e, tabsValue) => {
        this.setState({ tabsValue });
    };

    removeFromCompared(item) {
        const { compareItemsList } = this.props;
        this.props.DiamondsActions.setCompare(compareItemsList.filter(c => c !== item))
    }

    onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const compareItemsList = reorder(
            this.props.compareItemsList,
            result.source.index,
            result.destination.index
        );

        this.props.DiamondsActions.setCompare(compareItemsList)
    }

    render() {
        const { sideDrawerOpen, tabsValue, row } = this.state;
        let { classes, /* authUser,  */ isAuthorised, compareItemsList = [], diamondsDocs = [], areDiamondsLoading, fxrates = [], ccy, width, diamond_available = {} } = this.props;
        const isMobile = width === 'xs';

        const isSingleLabs = tabsValue === 1;
        const isParcel = tabsValue === 2;

        diamondsDocs = (diamondsDocs || []).map((d, index) => {
            d.WebSpecial = d.WebSpecial && parseFloat(d.WebSpecial) || 0;
            return ({
                ...{
                    ...d,
                    img: `/images/${isOtherShape(isParcel, d.StkShape) ? 'round' : d.StkShape.toLowerCase()}${isParcel ? '_parcel.png' : '.png'}`,
                    colour: joinHenigArray(d, 'Colour'),
                    clarity: joinHenigArray(d, 'Clarity'),
                    cut: joinHenigArray(d, 'Cut'),
                    flourecence: joinHenigArray(d, 'flourecence'),
                    symmetry: joinHenigArray(d, 'Symmetry'),
                    polish: joinHenigArray(d, 'Polish'),
                    size: joinHenigArray(d, 'Size'),
                    availability: d.Availability || d.StkWebAvailable,
                    priceOrig: d.price,
                    ppcOrig: d.ppc,
                    price: d.WebSpecial || d.price || d.ExWebTotal,
                    ppc: d.WebSpecial || d.ppc || d.ExWebTotal,
                    specialOffer: d.WebSpecial ? true : false,
                    cut: joinHenigArray(d, 'Cut'),
                    sieve: joinHenigArray(d, 'Sieve'),
                },
            })
        })

        const compareItemsListInTab = compareItemsList.filter(a => diamondsDocs.find(d => d._id === a && ((isParcel && d.StkCatType === 'Multiple Items') || (!isParcel && d.StkCatType === 'Single Item'))));

        return (<div className={classNames(style.wrapper, 'dark-support')}>

            <SecondaryNav
                value="compare"
                openDiamondSideDrawer={sideDrawerOpen}
                closeBag={this.closeBag}
                sideDrawerProps={{ row }}
            />

            <div className={style.inner}>
                <SingleAndParcelsTabs value={tabsValue} onChange={this.onTabsChange} />

                {!areDiamondsLoading && !compareItemsListInTab.length && <div className={style.emptyListMsg}>
                    <h2>Your {isParcel ? 'Parcel' : 'Single'} Compare List</h2>
                    <h3>Is Currently Empty</h3>
                </div>}

                {!areDiamondsLoading && compareItemsListInTab.length > 0 && <div className={style.compareTable}>
                    {!isMobile && <div>
                        <CompareItem emptyPlaceholder />
                        <div className={classNames(style.compareProperties, style.comparePropertiesLabels)}>
                            <div>Shape</div>
                            <div>Weight</div>
                            <div>Colour</div>
                            <div>Clarity</div>
                            <div>Cut</div>
                            <div>Polish</div>
                            <div>Symmetry</div>
                            <div>Fluorescence</div>
                            <div>Stock Code</div>
                            <div>Availability</div>
                            <div></div>

                            {isAuthorised && <React.Fragment>
                                <div>PPC</div>
                                <div>Rap Below %</div>
                                <div>Price</div>
                                <div>Special Price</div>
                            </React.Fragment>}

                            <div></div>
                            <div>Lab</div>
                            <div>Report Number</div>

                            <div>Depth %</div>
                            <div>Table %</div>
                            <div>Measurements</div>
                            <div>L/W Ratio</div>
                        </div>
                    </div>}
                    <DragDropContext onDragEnd={result => this.onDragEnd(result)}>
                        <Droppable droppableId="droppable" direction={isMobile ? 'vertical' : 'horizontal'}>
                            {(provided, snapshot) => (
                                <div
                                    ref={provided.innerRef}
                                    style={getListStyle(snapshot.isDraggingOver, isMobile)}
                                    {...provided.droppableProps}
                                >
                                    {compareItemsList.map((item, index) => {
                                        const diamondItem = diamondsDocs.find(d => d._id === item && ((isParcel && d.StkCatType === 'Multiple Items') || (!isParcel && d.StkCatType === 'Single Item')));
                                        if (!diamondItem) return;

                                        if(!isParcel){
                                            // if we need single labs but the item is not, exclude it
                                            if(isSingleLabs && (diamondItem.Source !== "Lab Grown")) return;

                                            // if we need single natural but the item is not, exclude it
                                            if(!isSingleLabs && (diamondItem.Source === "Lab Grown" || diamondItem.StkCatName === "Lab Grown Diamonds")) return;
                                        }

                                        return (
                                            <Draggable key={item} draggableId={item} index={index}>
                                                {(provided, snapshot) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        style={getItemStyle(
                                                            snapshot.isDragging,
                                                            provided.draggableProps.style,
                                                            isMobile,
                                                        )}
                                                    >
                                                        <div className={style.compareItemWrap}>
                                                            <CompareItem
                                                                onCloseClick={() => this.removeFromCompared(item)}
                                                                dragHandleProps={provided.dragHandleProps}
                                                                isDragging={snapshot.isDragging}
                                                                diamondItem={diamondItem}
                                                                isParcel={isParcel}
                                                            />

                                                            <div className={style.comparePropertiesWrap}>
                                                                {isMobile && <div className={style.compareProperties}>
                                                                    <div>Shape</div>
                                                                    <div>Weight</div>
                                                                    <div>Colour</div>
                                                                    <div>Clarity</div>
                                                                    <div>Cut</div>
                                                                    <div>Polish</div>
                                                                    <div>Symmetry</div>
                                                                    <div>Fluorescence</div>
                                                                    <div>Stock Code</div>
                                                                    <div>Availability</div>
                                                                    <div></div>

                                                                    {isAuthorised && <React.Fragment>
                                                                        <div>PPC</div>
                                                                        <div>Rap Below %</div>
                                                                        <div>Price</div>
                                                                        <div>Special Price</div>
                                                                    </React.Fragment>}

                                                                    <div></div>
                                                                    <div>Lab</div>
                                                                    <div>Report Number</div>

                                                                    <div>Depth %</div>
                                                                    <div>Table %</div>
                                                                    <div>Measurements</div>
                                                                    <div>L/W Ratio</div>
                                                                </div>}

                                                                <div className={classNames(style.compareProperties, style.comparePropertiesValues)}>
                                                                    <div>{diamondItem.StkShape || '-'}</div>
                                                                    <div>{isParcel ? diamondItem.size || '-' : `${numeral(diamondItem.STWeight).format('0.00')}ct`}</div>
                                                                    <div>{joinHenigArray(diamondItem, 'Colour') || '-'}</div>
                                                                    <div>{joinHenigArray(diamondItem, 'Clarity') || '-'}</div>
                                                                    <div>{joinHenigArray(diamondItem, 'Cut') || '-'}</div>
                                                                    <div>{joinHenigArray(diamondItem, 'Polish') || '-'}</div>
                                                                    <div>{joinHenigArray(diamondItem, 'Symmetry') || '-'}</div>
                                                                    <div>{diamondItem.flourecence || '-'}</div>
                                                                    <div>{diamondItem.StkCodeCalcNS || '-'}</div>

                                                                    {isAuthorised &&
                                                                        <div className={(diamondItem.availability === 1 && style.availability) || undefined}>
                                                                            {diamondItem.availability === 1 ? (diamond_available['diamond_available_now'] || valuesMapAvailability['1']): ''}
                                                                            {diamondItem.availability === 2 ? (diamond_available['diamond_available_later'] || valuesMapAvailability['2']): ''}
                                                                            {diamondItem.availability === 3 ? (diamond_available['diamond_available_on_demand'] || valuesMapAvailability['3']): ''}
                                                                        </div>
                                                                    }
                                                                    {!isAuthorised &&
                                                                        <div>
                                                                            <RegisterOrLoginToSeePriceNotice openEmailDialog={this.props.openEmailDialog} description='' />
                                                                        </div>
                                                                    }


                                                                    <div></div>

                                                                    {isAuthorised && <React.Fragment>
                                                                        {!isParcel && <div>{getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(diamondItem.price, false, fxrates, ccy)) / parseFloat(diamondItem.STWeight)).format('0,0.00')}</div>}
                                                                        {isParcel && <div>{getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(diamondItem.ppc, true, fxrates, ccy))).format('0,0.00')}</div>}

                                                                        <div>{diamondItem.RAP ? diamondItem.RAP + '%' : '-'}</div>

                                                                        {!isParcel && <div>{getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(diamondItem.priceOrig, false, fxrates, ccy))).format('0,0.00')}</div>}
                                                                        {isParcel && <div>{getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(diamondItem.ppcOrig, true, fxrates, ccy))).format('0,0.00')}</div>}

                                                                        {!diamondItem.specialOffer && <div>-</div>}
                                                                        {diamondItem.specialOffer && <div>
                                                                            {isParcel && `${getSymbolFromCurrency(ccy)}${numeral(Math.round(convertToCurrency(diamondItem.WebSpecial, true, fxrates, ccy))).format('0,0.00')}`}
                                                                            {!isParcel && `${getSymbolFromCurrency(ccy)}${numeral(Math.round(convertToCurrency(diamondItem.price, false, fxrates, ccy))).format('0,0.00')}`}
                                                                        </div>}
                                                                    </React.Fragment>}

                                                                    <div></div>
                                                                    <div>{diamondItem.StkCertSup || '-'}</div>
                                                                    <div>{diamondItem.StkCertNo || '-'}</div>

                                                                    <div>{diamondItem.StkDepth_Total ? diamondItem.StkDepth_Total + '%' : '-'}</div>
                                                                    <div>{diamondItem.StkTable ? diamondItem.StkTable + '%' : '-'}</div>
                                                                    <div>{[diamondItem.StkMes1, diamondItem.StkMes2, diamondItem.StkMes3].map(s => s && `${s}` || '-').join(' x ')}</div>
                                                                    <div>{diamondItem.StkMes1 && diamondItem.StkMes2 ? numeral((diamondItem.StkMes1 / diamondItem.StkMes2)).format('0.00') : '-'}</div>

                                                                </div>
                                                            </div>
                                                            <div className={style.actionsWrap}>
                                                                <Button
                                                                    type="button"
                                                                    variant="contained"
                                                                    color="secondary"
                                                                    onClick={() => this.openBag(diamondItem)}
                                                                    disabled={!isAuthorised}
                                                                >Add to Basket</Button>

                                                                <Link to={`/diamonds/${diamondItem._id}/details`} className={classes.noDecoration}>
                                                                    <Button
                                                                        type="button"
                                                                        variant="contained"
                                                                        color="default"
                                                                    >View Details</Button>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>
                                        )
                                    })}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                </div>}


            </div>

        </div >);
    }
}

Compare.propTypes = {
    selectCompare: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    width: PropTypes.string.isRequired,
};



export default connect(
    (state) => ({
        authUser: state.auth.user,
        isAuthorised: state.auth.isAuthorised,
        compareItemsList: state.diamonds.compare,
        diamondsDocs: state.diamonds.data && state.diamonds.data.docs,
        areDiamondsLoading: !state.diamonds || !state.diamonds.data || !state.diamonds.data.docs || !state.diamonds.data.docs.length,
        ccy: state.site.ccy,
        fxrates: state.site.fxrates,
        diamond_available: state.site.diamond_available,
    }),
    (dispatch) => ({
        AuthActions: bindActionCreators({ ...AuthActions }, dispatch),
        DiamondsActions: bindActionCreators({ ...DiamondsActions }, dispatch),
    })
)(withWidth()(withStyles(styles, { withTheme: true })(Compare)));
